export default "__VITE_ASSET__Qs$s4zbr__"